import type { IngestionItem } from '../store/useFormCGIAStore';

/**
 * Partie d'un PDF multi-documents découpé par le backend (skip-446), telle que
 * renvoyée par /api/ocr/cg/auto-extract dans `split.parts`.
 */
export interface PdfSplitPart {
  url: string;
  fromPage: number;
  toPage: number;
  docType: string;
}

const pagesLabel = (part: PdfSplitPart): string =>
  part.fromPage === part.toPage ? `p. ${part.fromPage}` : `p. ${part.fromPage}-${part.toPage}`;

/**
 * Un item d'ingestion par partie, prêt à être analysé comme un dépôt déjà
 * uploadé (`firebaseUrl` renseignée, pas de `File`). Le nom garde celui du PDF
 * d'origine suivi des pages, pour que l'agence s'y retrouve dans la checklist.
 *
 * Ids dérivés de l'item d'origine : un même PDF redécoupé réécrit les mêmes
 * items au lieu d'empiler des doublons.
 */
export const buildSplitPartItems = (original: IngestionItem, parts: PdfSplitPart[]): IngestionItem[] =>
  parts.map((part, index) => ({
    id: `${original.id}-part${index + 1}`,
    fileName: `${original.fileName} (${pagesLabel(part)})`,
    fileSize: 0,
    mimeType: 'application/pdf',
    status: 'queued' as const,
    firebaseUrl: part.url,
    createdAt: original.createdAt + index,
  }));
